<template>
    <div class="learners__assessment__data learners__progress">
        <span class="progress__numbers">{{ overallProgress }}%</span>

        <div class="learners__progress__bar" ref="progressTooltip">
            <div class="learners__progress" :style="{ width: `${overallProgress}%` }"></div>

            <!-- Tooltip Content -->
            <div ref="tooltipContent" class="progress-tooltip-content">
                <p class="progress-tc-title">Info - Groups Progress</p>
                <div v-for="(group, index) in groups" :key="index" class="progress-tc-pb-info">
                    <div class="tc-pb-info">
                        <span>Group {{ index }} - {{ group.percentage }}%</span>
                        <span>Score : {{ group.score }}/{{ group.total }}</span>
                    </div>
                    <div class="learners__progress__bar">
                        <div class="learners__progress" :style="{ width: `${group.percentage}%` }"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import tippy from 'tippy.js';

defineProps({
    overallProgress: {
        type: Number,
        required: true
    },
    groups: {
        type: Object,
        required: true,
        default: () => {} // Array of objects: [{ percentage: 12, score: 3, total: 3 }, ...]
    }
});

const progressTooltip = ref(null);
const tooltipContent = ref(null);

onMounted(async () => {
    await nextTick();
    if (!progressTooltip.value || !tooltipContent.value) return;

    tippy(progressTooltip.value, {
        content: tooltipContent.value,
        // trigger: 'click',
        placement: 'top',
        allowHTML: true,
        interactive: true,
        theme: 'light-border',
    });
});
</script>
